'use strict'

import { BasePlugin } from '@uppy/core'

export default class UppyUrlDrop extends BasePlugin {
  constructor (uppy, opts) {
    super(uppy, opts)

    this.type = 'acquirer'
    this.id = this.opts.id || 'UppyUrlDrop'
  }

  handleRootDrop = async (event) => {
    event.preventDefault()
    event.stopPropagation()

    const files = []

    if (event.dataTransfer && event.dataTransfer.types.length > 1) {
      for (let n = 0; n < event.dataTransfer.files.length; n++) {
        files[n] = event.dataTransfer.files[n]
      }

      if (files.length) {
        this.addFiles(files)
      }
    }
  }

  addFiles (files) {
    const descriptors = files.map(file => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file
    }));

    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
}
